<template>
  <div class="container-fluid">
    <h3 class="mb-3">Клиенты</h3>

    <div class="card p-3 border-bottom-0 border-left-0 border-right-0 border-primary border-top shadow">
      <div class="input-group mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text" id="basic-addon3">Поиск: </span>
        </div>
        <input type="text" class="form-control" v-model="search"/>
      </div>

      <div class="row text-secondary font-weight-bold py-2 text-center">
        <div class="col-5">ФИО</div>

        <div class="col-7">
          <div class="row">
            <div class="col-4">Назначено</div>

            <div class="col-4">Куплено</div>

            <div class="col-4">Начато</div>
          </div>
        </div>
      </div>

      <div class="row border-top py-2 pointer"
           v-for="(client, clientKey) in clients"
           :key="clientKey"
           @click="selectClientId(client.id)">
        <div class="col-5">
          <div class="media">
            <img :src="client.image.url"
                 width="40"
                 class="img-thumbnail rounded-circle mr-3"
                 alt="...">
            <div class="media-body">
              <div class="font-weight-bold">{{ client.name }}</div>
              <div class="opacity-50">{{ client.email }}</div>
            </div>
          </div>
        </div>

        <div class="col-7">
          <div class="row py-2 text-center">
            <div class="col-4">
              {{client.countPrescriptions}}
            </div>

            <div class="col-4">
              <i class="fas fa-ban text-muted opacity-30" v-if="client.countPrescriptions === 0"></i>
              <i class="fas fa-times text-danger opacity-30" v-else-if="client.hasNotBoughtDrugs"></i>
              <i class="fas fa-check text-success" v-else></i>
            </div>

            <div class="col-4">
              <i class="fas fa-ban text-muted opacity-30" v-if="client.countPrescriptions === 0"></i>
              <i class="fas fa-times text-danger opacity-30" v-else-if="client.hasNotStartedPrescriptions"></i>
              <i class="fas fa-check text-success" v-else></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ClientList',

    data() {
      return {
        search: '',
      };
    },

    computed: {
      clients() {
        const clients = this.$store.state.clients.map(client => {
          const stats = this.$store.getters.clientDrugStats(client.id);

          return {
            id: client.id,
            name: client.name,
            email: client.email,
            image: client.image,
            countPrescriptions: stats.cntTotal || 0,
            hasNotStartedPrescriptions: stats.cntTotal > stats.cntStarted,
            hasNotBoughtDrugs: stats.cntTotal > stats.cntBought,
          };
        });

        clients.sort((a, b) => a.name === b.name ? 0 : (a.name > b.name ? 1 : -1));

        return clients.filter(client => {
          if (typeof this.search !== 'string' || this.search.trim() === '') {
            return true;
          }

          return client.name.toLowerCase().indexOf(this.search.toLowerCase()) !== -1;
        });
      }
    },

    methods: {
      selectClientId(clientId) {
        this.$store.dispatch('CHOOSE_CLIENT', clientId);
      },
    }
  };
</script>
